
		<cache-date></cache-date>
		
		<hr/>
		
		<div *ngFor="let folder of images" [sextant]="'test-view-folder'">
			<div *ngFor="let subFolder of folder" class="test-view-container">
				<h3>
					{{ subFolder[0].folder }}: {{ subFolder[0].subFolder }}
				</h3>
				
				<ngb-carousel *ngIf="subFolder">
					<ng-template *ngFor="let image of subFolder" ngbSlide>
						<img
							[src]="getUrl(image)"
							class="img-fluid"
						/>
						<div class="carousel-caption" style="color: black;">
							<h3>
								{{ image.file }}
							</h3>
						</div>
					</ng-template>
				</ngb-carousel>
				
				<hr/>
			</div>
			
			<hr/>
		</div>
	